import { MAX_TIME_FOR_EDITING_OR_DELETING_REPORT_MESSAGE } from './reportMessage';

export const INFO_ADMIN_GRAPH_VIEWER_NOTE =
  'Please note, the graph viewer below is currently limited to displaying the top 1000 nodes only.';

export const INFO_REPORT_MESSAGE_EDIT_WINDOW_NOTE = `Report group messages can only be edited within ${MAX_TIME_FOR_EDITING_OR_DELETING_REPORT_MESSAGE} minutes of creation.`;

export const INFO_REPORT_GROUPS_NOTE =
  'Report groups collect message updates in dedicated buckets. Create one (using small-case snake_case names like daily_tech_standup) to keep your updates organized and easy to reference.';

export const INFO_REALTIME_NON_PRO_NOTICE =
  "You are on Hana's FREE plan. Voice mode still works for day-to-day help. Upgrade to PRO to unlock deeper reasoning, stronger instruction following, and richer workflows. Example: ask Hana to summarize a long meeting thread and return owners, risks, and next actions.";

export const INFO_MULTIMODAL_ONLY_PRO_PLAN_NOTE =
  'Complex ingestion algorithms that consider images (multimodal) are only available on the Pro plan. Other plans process plain text.';

export const UPGRADE_TO_PRO_BUTTON_LABEL = 'Upgrade to Pro';

export const INFO_SPACES_NOTE =
  'Spaces will automatically appear here as you add Hana to more spaces in Google Chat.';

export const INFO_GOOGLE_DRIVE_FILE_TYPES_NOTE =
  'Google Drive memory supports only Google Docs, Google Slides, Google Sheets (CSV), PDFs, plain text (.txt, .md), JSON and CSV files.';
